"use client";

import useTranslationApi from "@/lib/hooks/useTranslationApi";

export default function LabelMore() {
	const { t } = useTranslationApi(["lable_view_more"]);
	return <>{t("lable_view_more")}</>;
}
